import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22.41 12L12 1.59 1.59 11.99 12 22.41 22.41 12zM14 14.5V12h-4v3H8v-5h6V7.5l3.5 3.5-3.5 3.5z"
}), 'DirectionsSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/DirectionsSharp.js
// module id = 3191
// module chunks = 2